import styled from 'styled-components';
import { device } from 'styles/breakpoints';

export const DatePickerWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  margin-top: 15px;
  max-width: 250px;
  input {
    width: 100%;
    padding-bottom: 5px;
    border: none;
    background-color: transparent;
    border-bottom: 1px solid #cac8b0;
    font-size: 20px;
    line-height: 24px;
    padding: 0px 0px 8px;
    border-radius: 0;
    width: 100%;

    &:focus {
      outline: none;
      box-shadow: rgb(100 78 2) 0px 2px;
    }
    &::placeholder {
      color: #cac8b0;
      letter-spacing: 2px;
      opacity: 1;
    }
  }
  @media ${device.tablet} {
    margin-top: 5px;
  }
`;
